export default "__VITE_ASSET__D7GtcWd1__";